// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_UVEpR","itemDots":"index_itemDots_Jp8Qn","itemPicContainer":"index_itemPicContainer_1zqeY","itemPic":"index_itemPic_7ZjwT","itemIcon":"index_itemIcon_15J7u"};